<template>
  <v-layout justify-center>
    <v-flex xs12 sm12 class="mt-2">
      <v-card>
        <v-card-title>
          
            <span class="red--text headline"
              >Compare Subscription Packages</span
            >
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              small
              dark
              class="no-uppercase v-btn--large bg-blue white--text v-btn--round"
              @click="hide"
            >
              hide comparison
            </v-btn>
          
        </v-card-title>
        <v-divider></v-divider>
        <v-container fluid grid-list-md>
            <v-layout row md12 sm12 xs12 lg12 class="mb-1">
              <v-flex md9 sm9 lg9 xs9 class="heading"> Services </v-flex>
              <v-flex sm1 md1 lg1 xs1 class="heading"> Basic </v-flex>
              <v-flex sm1 md1 lg1 xs1 class="heading"> Premium </v-flex>
              <v-flex sm1 md1 lg1 xs1 class="heading"> Corporate </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Survey Creation Per Month</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p class="text-center">5</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p class="text-center">10</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p class="text-center">20</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Responses Per Survey Per Month</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>100</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>1000</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>5000</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Respondent Filter Allowed</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Respondent Filter Limit</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>5</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>10</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Analytics Visualization Allowed (Response Data presented with bars and charts)</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Questions Per Survey</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>10</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>200</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>500</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Users Allowed</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>1</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>3</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>5</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Roles for Client’s Admin Allowed</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Bi-Monthly Project Progress Report via Email Notifications</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
               <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Dashboard Reporting Allowed</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
               <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Request for Audit Services by the DataDash Team Allowed (not part of subscription – charges are separate)	</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
               <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Request for Advanced Analytics Allowed (not part of subscription – charges are separate)</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="green">check_circle</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Audio/Visual Question Types Allowed</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="green">check_circle</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Dasher Ranking Filter Allowed	</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
               <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Response Download Allowed	</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Conditional Question allowed	</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Pre-Survey Module Allowed</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="green">check_circle</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Mobile OTP Verification Allowed</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="green">check_circle</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="green">check_circle</v-icon></v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Dasher Teams</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>5</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>15</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Allowed Dashers on the team</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>20</p> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>100</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Agent Group</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>15</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Number of Agents in a group</p></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1><v-icon class="material-symbols-outlined" color="red">cancel</v-icon></v-flex>
              <v-flex sm1 md1 lg1 xs1> <p>100</p> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row md12 sm12 xs12 lg12 class="mt-1">
              <v-flex md9 sm9 lg9 xs9> <p>Project Summary Report Download	</p></v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="red">cancel</v-icon> </v-flex>
              <v-flex sm1 md1 lg1 xs1> <v-icon class="material-symbols-outlined" color="green">check_circle</v-icon> </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn
            color="white darken-1"
            small
            dark
            class="no-uppercase red--text"
            @click="back"
          >
            back
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import router from "@/router";
export default {
  data: () => ({
    show: true,
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    back() {
      router.push("/subscription-package");
    },
    hide() {
      this.$emit("hide");
    },
  },
};
</script>
<style scoped>
.heading{
  font-size: 14px;
  font-weight: 500;
}
</style>
